import GuestVerification from './components/guestVerification';
import React from 'react';

const GuestVerificationHome = () => {
	return (
		<>
			<GuestVerification />
		</>
	);
};

export default GuestVerificationHome;
